const DEFAULTS = {
  jweAlgorithm: 'RSA-OAEP-256',
  jweEncryption: 'A256GCM',
  jweKid: '',
  jwePublicJwk: '',
  isDevelopment: process.env.NODE_ENV !== 'production'
};
let current = {
  ...DEFAULTS
};
export const setBiometricsConfig = (next = {}) => {
  current = {
    ...DEFAULTS,
    ...Object.fromEntries(Object.entries(next).filter(([, value]) => value !== undefined && value !== ''))
  };
};
export const getBiometricsConfig = () => current;